












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class VisitsVisitorsContactsAvgCharts extends BaseComponent {
  @Prop()
  kpis: any[];
  
  @Prop()
  configs: any;

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {
    backgroundColor: 'transparent',
    chartArea: { left: '200', top: '0', right: '20', bottom: '50' },
    legend: { position: 'bottom' },
    isStacked: false,
    colors: ['102D69'],
    fontSize: 12,
    hAxis: {
      minValue: 0
    },
    series: {
      1: {
        type: 'line',
        color: '#00AA00',
        lineDashStyle: [12, 6],
        lineWidth: 2,
        pointSize: 0
      }
    }
  };

  mounted() {
    this.load();
  }

  load() {
    this.chartData = [];

    this.chartData.push(['Usuário', 'Média de contatos por visita', { role: 'annotation' }, 'Meta']);
    this.kpis.forEach((i) => {
      this.chartData.push([
        `${StringUtils.abbreviate(i.nome, 25)}`,
        i.qtdeMediaContatos,
        i.qtdeMediaContatos,
        this.getGoalValue()
      ]);
    });

  }

  @Watch('kpis', { immediate: true })
  @Watch('configs', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }

  getGoalValue() {
    return !!this.configs ? this.configs.qtdeMetaContatosVisita : null;
  }
}
